import React, { Component, Fragment } from "react";
import $, { data } from "jquery";
import { ToastContainer, toast } from "react-toastify";
//import ProgressBar from 'react-bootstrap/ProgressBar';
import { ListViewComponent } from "@syncfusion/ej2-react-lists";
import { enableRipple } from "@syncfusion/ej2-base";
import { TreeViewComponent } from "@syncfusion/ej2-react-navigations";
import ReactTable from "react-table-6";
import Select from "react-select";
import ComboBox from "react-responsive-combo-box";
import "react-responsive-combo-box/dist/index.css";

window.escalatedChatDataMap = [];
window.conversationIdUtteranceDataMap = [];
window.escalatedConversationDataMap = [];
window.wsConnectionDataMap = [];
window.wsConnectionObjectMap = [];
window.sourceJid = null;
window.wsConnectionObjectMapByConversationId = [];

class CustomerChat extends Component {
  constructor() {
    super();
    this.state = {
      advancePropertyfileTypes: [],
      advancePropertyValueString: "",
      showChatsPopUp: false,
      selectedWhatsapp: false,
      selectedGoogleRcs: false,
      showWhatsapp: false,
      showGoogleRcs: false,
      buttonDisabled: true,
      hideChoseFile: false,
      alignLeft: false,
      highLightedChatIdList: [],
      activeLeadsArray: [],
      leadUtteranceArray: [],
      leadId: null,
      nameOfTheUser: "",
      value: "",
      showHistory: true,
      data: [],
      fileInBase64: {},
      maskPhoneNumbers: false,
      leadNumberToIdMap: {},
      selectedLeadNumber: null,
      numberOfParams: 0,
      templateParams: [],
      selectedTemplateContent: ""
    };
    this.loadLeads = [];
    this.nameAndPhoneNumberData = [];
    this.fields_list = {
      id: "conversationId",
      text: "userDisplayName",
      groupBy: "escalationTag",
    };
  }

  initWebSocket(callback) {
    if (this.chatSocket && this.chatSocket.readyState === WebSocket.OPEN) {
      console.log("WebSocket already open.");
      if (callback) callback();
      return;
    }

    const loc = window.location;
    const converseUrl = `${loc.protocol === "https:" ? "wss:" : "ws:"}//${loc.host}/salesdesk-api/converse`;
    const socket = new WebSocket(converseUrl);
    socket.binaryType = "arraybuffer";
    this.chatSocket = socket;

    const userDetails = JSON.parse(localStorage.getItem("user_details"));

    // WebSocket open event: send initialization message
    socket.addEventListener("open", () => {
      const initMessage = {
        init: "true",
        userId: userDetails.userId,
        email: userDetails.emailId,
        fullName: userDetails.name,
        contactNumber: userDetails.mobileNumber,
      };
      socket.send(JSON.stringify(initMessage));
      if (callback) {
        callback();
      }
    });

    // Handle WebSocket errors
    socket.addEventListener("error", (e) => {
      console.error("WebSocket error occurred:", e);
    });

    // Handle incoming messages
    socket.onmessage = (message) => {
      try {
        if (typeof message.data === "string") {
          const data = JSON.parse(message.data);
          this.processIncomingMessage(data, userDetails);
        }
      } catch (error) {
        console.error("Error processing incoming message:", error);
      }
    };

  }

  componentDidMount() {
    // Clear previously stored lead and platform information
    localStorage.removeItem("selectedConversationId");
    localStorage.removeItem("selectedLeadNumber");
    localStorage.removeItem("selectedSocialPlatform");

    // Set up WebSocket connection
    this.initWebSocket();
    // Request notification permissions if not granted
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    // Fetch initial data
    setTimeout(() => {
      this.fetchAdvanceProperties();
      this.fetchTemplatesInProject();
      this.fetchActiveLeads();
      this.fetchLeadDetails();
    }, 300);

    // Listen for project change events
    document.addEventListener("projectChanged", () => {
      this.loadLeads = [];
      this.setState({ leadUtteranceArray: [] });
      this.fetchAdvanceProperties();
      this.fetchTemplatesInProject();
      this.fetchActiveLeads();
      this.fetchLeadDetails();
    });
  }

  processIncomingMessage = (data, userDetails) => {
    console.log("[ChatHandler] Received message data:", data);

    let chatMessage;
    if (typeof data === "string") {
      try {
        chatMessage = JSON.parse(data);
      } catch (e) {
        console.error("[ChatHandler] Failed to parse incoming message:", e);
        return;
      }
    } else if (typeof data === "object") {
      chatMessage = data;
    } else {
      console.warn("[ChatHandler] Unknown message format:", data);
      return;
    }

    const conversationId = this.sanitizePhoneNumber(chatMessage.from);
    const destinationKey = this.sanitizePhoneNumber(chatMessage.destination);
    chatMessage.conversationId = conversationId;

    const selectedConversationId = localStorage.getItem("selectedConversationId");
    const incomingLeadId = chatMessage.leadId;

    // Check if lead exists
    const leadExists = this.state.activeLeadsArray.some(
      (lead) => lead.leadId === incomingLeadId
    );

    if (!leadExists) {
      console.warn(`[ChatHandler] Lead ID ${incomingLeadId} not found. Fetching active leads...`);
      this.fetchActiveLeads(); // Fetch in background
    }

    const updatedActiveLeads = this.state.activeLeadsArray.map((lead) => {
      if (lead.leadId === incomingLeadId) {
        const updatedLead = { ...lead };

        if (
          chatMessage.leadName &&
          chatMessage.leadName !== "Name not Available" &&
          (lead.userDisplayName === "Name not Available" || lead.userDisplayName !== chatMessage.leadName)
        ) {
          updatedLead.userDisplayName = chatMessage.leadName;
        }

        if (selectedConversationId !== incomingLeadId) {
          updatedLead.unreadMessages = (lead.unreadMessages || 0) + 1;
        }

        return updatedLead;
      }
      return lead;
    });

    const existingConversation = window.escalatedChatDataMap[destinationKey];
    const selectedConversation = this.getOrCreateConversation(chatMessage, userDetails, existingConversation);
    const formattedData = this.formatSingleUtterance(chatMessage, selectedConversation);

    if (selectedConversationId === incomingLeadId) {
      this.updateStateForSelectedConversation(formattedData, chatMessage);
    }

    this.setState((prevState) => ({
      activeLeadsArray: updatedActiveLeads,
      highLightedChatIdList: [...prevState.highLightedChatIdList, conversationId],
    }));

    localStorage.removeItem("conversationData");
    this.setEscalatedChatList();
  };


  // Utility to strip "+" or other formatting from phone numbers
  sanitizePhoneNumber = (phone) => {
    return phone ? phone.replace(/\+/g, "").trim() : "";
  };

  getOrCreateConversation = (chatMessage, userDetails, existingConversation) => {
    const from = userDetails.mobileNumber;
    chatMessage.from = chatMessage.from || from;
    const sanitizedFrom = this.sanitizePhoneNumber(chatMessage.from);
    const sanitizedDestination = this.sanitizePhoneNumber(chatMessage.destination);

    if (!existingConversation) {
      const newConversation = {
        messageId: chatMessage.id,
        userDisplayName: this.state.nameOfTheUser || chatMessage.leadName,
        id: sanitizedFrom,
        salesUserName: userDetails.name,
        userPhoneNumber: chatMessage.from,
        conversationId: sanitizedFrom,
        status: "new",
      };
      window.escalatedChatDataMap[sanitizedDestination] = newConversation;
      return newConversation;
    }

    if (existingConversation.userDisplayName === "Name not Available") {
      existingConversation.userDisplayName = chatMessage.leadName;
    }

    return existingConversation;
  };


  updateStateForSelectedConversation = (formattedData, chatMessage) => {
    const updatedActiveLeadsArray = this.state.activeLeadsArray.map((lead) => {
      if (lead.conversationId === chatMessage.conversationId) {
        return { ...lead, handleClick: true, unreadMessages: 0 };
      }
      return lead;
    });

    let leadUtteranceArray = this.state.leadUtteranceArray || [];

    const existingMessageIndex = leadUtteranceArray.findIndex(
      (lead) => lead.messageId === formattedData.messageId
    );

    if (existingMessageIndex !== -1) {
      leadUtteranceArray[existingMessageIndex] = {
        ...leadUtteranceArray[existingMessageIndex],
        messageStatus: formattedData.messageStatus,
        errorMessage: formattedData.errorMessage,
      };
    } else {
      if (formattedData.incoming) {
        leadUtteranceArray.push(formattedData);
      } else {
        leadUtteranceArray = leadUtteranceArray.map((lead) =>
          lead.messageId === formattedData.messageId ? formattedData : lead
        );
      }
    }

    this.setState({
      leadUtteranceArray,
      activeLeadsArray: updatedActiveLeadsArray,
    });
  };

  fetchAdvanceProperties = () => {
    const projectId = localStorage.getItem("currentProjectId");
    const accessToken = localStorage.getItem("access_token");
    const projectRole = localStorage.getItem("PROJECT_ROLE");
    const advancePropertyController = this;

    $.ajax({
      url: "/salesdesk-api/advance-properties",
      method: "GET",
      async: false,
      data: { projectId },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      success: function (res) {
        if (res.success === true && Array.isArray(res.result)) {
          const properties = res.result;

          for (let i = 0; i < properties.length; i++) {
            const prop = properties[i];
            const name = prop.advancePropertyName;
            const value = prop.advancePropertyValue;

            if (
              name === "MASK_LEAD_NUMBERS_FOR_SUPPORT_USERS" &&
              value && projectRole === "PROJECT_SUPPORT_USER"
            ) {
              advancePropertyController.state.maskPhoneNumbers = true;
            }

            if (name === "ALLOWED_UPLOAD_TYPE" && value) {
              const types = value.split(",");
              const allowedTypes = types.map(t => t.trim().substring(2));
              const allowedTypesString = types.map(t => t.trim().substring(1)).join(", ");

              advancePropertyController.state.advancePropertyfileTypes = allowedTypes;
              advancePropertyController.state.advancePropertyValueString = allowedTypesString;

              console.log("File types allowed:", allowedTypesString);
            }
          }

          advancePropertyController.setState(advancePropertyController.state);
        } else {
          advancePropertyController.notifyError(res.result || "No properties found.");
        }
      },
      error: function (xhr) {
        if (xhr.status === 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`Got error status: ${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  fetchProjectDetails() {
    $.ajax({
      url: "/api/project",
      async: false,
      method: "GET",
      data: {
        userId: JSON.parse(localStorage.getItem("user_details"))["userId"],
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("currentProjectId", res.result[0].id);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      },
    });
  }
  handleLeadChange = (e) => {
    console.log("Selected / entered a lead with number: ", e);
    this.state.selectedLeadNumber = e;
    localStorage.setItem("selectedLeadNumber", e);
    this.setState(this.state);
  };

  fetchLeadDetails = () => {
    const leadController = this;
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    const accessToken = localStorage.getItem("access_token");
    const projectId = localStorage.getItem("currentProjectId");

    $.ajax({
      url: "/salesdesk-api/lead-details",
      async: false,
      method: "POST",
      data: {
        salesExecutiveId: userDetails.userId,
        projectId: projectId,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      success: function (res) {
        if (res.success === true) {
          const loadLead = res.result;

          const leadNumberToIdMap = {};
          leadController.nameAndPhoneNumberData = []; // Reset the array before adding new data
          leadController.loadLeads = []; // Reset the array before adding new data

          // Process the leads
          loadLead.forEach((lead) => {
            leadController.nameAndPhoneNumberData.push({
              value: lead.name,
              label: lead.contactNumber,
            });

            leadController.loadLeads.push(lead.contactNumber);
            leadNumberToIdMap[lead.contactNumber] = lead.id;
          });

          console.log("Leads Number to Ids Map: ", leadNumberToIdMap);
          leadController.setState({ leadNumberToIdMap });
        } else {
          leadController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status === 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`Failed to fetch lead details: ${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  notifyNoData() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp; Please enter phone number before start to chat{" "}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchActiveLeads = () => {
    const projectId = localStorage.getItem("currentProjectId");
    const accessToken = localStorage.getItem("access_token");
    const projectRole = localStorage.getItem("PROJECT_ROLE");
    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    const salesExecId = userDetails.userId;

    $.ajax({
      url: "/salesdesk-api/fetch-active-leads",
      method: "GET",
      data: {
        projectId,
        projectRole,
        salesExecId,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      success: (res) => {
        if (res.success) {
          if (res.result.recordList.length > 0) {
            const leadConversationData = res.result.recordList.map(
              (result) => ({
                color: "Success",
                conversationId: this.normalisePhoneNumberForActiveLeads(
                  result.leadContactNumber
                ),
                escalationTag: "read",
                handleClick: result.handleClick,
                id: this.normalisePhoneNumberForActiveLeads(
                  result.leadContactNumber
                ),
                salesUserName: JSON.parse(localStorage.getItem("user_details"))
                  .name,
                status: "new",
                userDisplayName: result.leadName || "Name not Available",
                userPhoneNumberToDisplay: res.result.maskingRequired
                  ? "XXXXXXXXXX"
                  : result.leadContactNumber,
                userPhoneNumber: result.leadContactNumber,
                uxType: result.uxType,
                unreadMessages: result.noOfUnreadMessages || 0,
                enterpriseCrmId: result.enterpriseCrmId,
                selectedSocialPlatform:
                  result.conversationReportId.socialPlatform,
                icon: "assets/images/whatsapp-logo.png",
                leadId: result.conversationReportId.leadId,
              })
            );

            this.setState({ activeLeadsArray: leadConversationData });
          }
        } else {
          this.notifyError(res.result);
        }
      },
      error: (xhr) => {
        if (xhr.status === 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`Failed to fetch lead details: ${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyPhoneNumberInvalid() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Invalid Contact Number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  sendSocketMessage(socket) {
    if (socket) {
    }
  }

  startChatBySendingTemplate = () => {
    this.setState({ nameOfTheUser: "" });

    const contactNumberRaw = this.state.selectedLeadNumber;
    if (!contactNumberRaw) return this.notifyNoData();

    const contactNumber = this.formatPhoneNumber(contactNumberRaw);
    if (!contactNumber) return this.notifyPhoneNumberInvalid();

    const userDetails = JSON.parse(localStorage.getItem("user_details"));
    const templateElement = document.getElementById("loadTemplate");
    const templateName = templateElement ? templateElement.value : "";

    const timestamp = Date.now();
    const messageKey = {
      projectId: localStorage.getItem("currentProjectId"),
      leadId: null,
      socialPlatform: localStorage.getItem("selectedSocialPlatform"),
      time: timestamp,
    };

    const chatMessage = {
      from: userDetails.mobileNumber,
      destination: contactNumber,
      text: "",
      messageType: "TEMPLATE",
      leadName: this.state.nameOfTheUser || "Name not Available",
      salesUserId: userDetails.userId,
      salesUserEmailId: userDetails.emailId,
      conversationId: contactNumber.replace("+", ""),
      date: new Date().toISOString().split("T")[0],
      incoming: false,
      messageStatus: "SENT",
      key: messageKey,
      templateName,
      templateParams: this.generateTemplateParams(),
    };

    // Send via WebSocket (reconnect if needed)
    this.sendViaWebSocket(chatMessage);

    // Save to localStorage
    localStorage.setItem("selectedConversationId", contactNumber);
    localStorage.setItem("selectedLeadNumber", contactNumber);

    // Display "template sent" message in chat
    chatMessage.text = `The Template: ${templateName}`;

    let conversationId = contactNumber.replace("+", "");
    let selectedConversation =
      window.escalatedChatDataMap[conversationId] || this.createConversation(chatMessage, userDetails);

    const formattedData = this.formatSingleUtterance(chatMessage, selectedConversation);
    this.appendMessageToState(formattedData);

    // Load conversation history
    setTimeout(() => this.showHistoryApi(contactNumber), 1500);

    // Reset message input
    const textBox = document.getElementById("textMsg");
    if (textBox) textBox.value = "";

    // Ensure lead is in active leads
    this.ensureActiveLead(chatMessage, userDetails);

    this.setState({ showChatsPopUp: false });
  };
  sendViaWebSocket = (chatMessage) => {
    const socket = this.chatSocket;
    const message = JSON.stringify(chatMessage);

    if (socket.readyState === WebSocket.CLOSED || socket.readyState === WebSocket.CLOSING) {
      console.log("Reinitializing WebSocket...");
      this.initWebSocket(() => socket.send(message));
    } else {
      socket.send(message);
    }
  };

  generateTemplateParams = () => {
    return (this.state.templateParams || []).filter(p => p !== "");
  };

  createConversation = (chatMessage, userDetails) => {
    const id = chatMessage.destination.replace("+", "");
    const conversation = {
      userDisplayName: chatMessage.leadName,
      id,
      salesUserName: userDetails.name,
      userPhoneNumber: chatMessage.destination,
      conversationId: id,
      status: "seen",
    };
    window.escalatedChatDataMap[id] = conversation;
    return conversation;
  };

  appendMessageToState = (message) => {
    this.setState((prevState) => ({
      leadUtteranceArray: [...(prevState.leadUtteranceArray || []), message],
    }));
  };
  ensureActiveLead = (chatMessage, userDetails) => {
    const contactNumber = this.normalisePhoneNumberForActiveLeads(chatMessage.destination);
    const exists = this.state.activeLeadsArray.some(
      (lead) => lead.conversationId === contactNumber
    );

    if (!exists) {
      const newLead = {
        color: "Success",
        conversationId: contactNumber,
        escalationTag: "read",
        handleClick: false,
        id: contactNumber,
        incomingChatLogo: "./assets/images/web_icon_32.png",
        salesUserName: userDetails.name,
        status: "new",
        userDisplayName: chatMessage.leadName,
        userPhoneNumber: chatMessage.destination,
        userPhoneNumberToDisplay: this.state.maskPhoneNumbers ? "XXXXXXXXXX" : chatMessage.destination,
        uxType: undefined,
        unreadMessages: 0,
      };
      this.setState((prevState) => ({
        activeLeadsArray: [...(prevState.activeLeadsArray || []), newLead],
      }));
    }
  };

  // General formatter for display or sending
  formatPhoneNumber = (contactNumber) => {
    const phoneStr = String(contactNumber).replace(/\D/g, ""); // Remove non-digits
    if (phoneStr.length === 10) {
      return `+91${phoneStr}`;
    } else if (phoneStr.length === 12) {
      return `+${phoneStr}`;
    } else if (phoneStr.length === 13 && phoneStr.startsWith("91")) {
      return `+${phoneStr}`;
    }
    return null;
  };

  // Normalizes for API use or chat message (with '+')
  normalisePhoneNumber = (contactNumber) => {
    const phoneStr = String(contactNumber).replace(/\D/g, "");
    if (phoneStr.length === 10) {
      return `+91${phoneStr}`;
    }
    return phoneStr.startsWith("91") ? `+${phoneStr}` : `+${phoneStr}`;
  };

  // For internal mapping keys (numeric only)
  normalisePhoneNumberForActiveLeads = (contactNumber) => {
    const phoneStr = String(contactNumber).replace(/\D/g, "");
    return phoneStr.length === 10 ? `91${phoneStr}` : phoneStr;
  };

  sendMessage = () => {
    const {
      leadNumberToIdMap,
      nameOfTheUser,
      showGoogleRcs,
      selectedLeadNumber: stateLeadNumber,
    } = this.state;

    const selectedLeadNumber = this.getSelectedLeadNumber(stateLeadNumber);
    if (!selectedLeadNumber) {
      return this.notifyResponse("No Lead Selected!");
    }

    const inputElement = document.getElementById("textMsg");
    const messageText = inputElement && inputElement.value ? inputElement.value.trim() : "";

    if (!messageText) {
      return this.notifyResponse("Text is empty!");
    }

    const userDetails = this.getUserDetails();
    const socialPlatform = localStorage.getItem("selectedSocialPlatform");
    const chatTime = Date.now();

    const chatMessage = {
      from: userDetails.mobileNumber,
      destination: selectedLeadNumber,
      text: messageText,
      messageType: "TEXT",
      leadName: nameOfTheUser || "Name not Available",
      salesUserId: userDetails.userId,
      salesUserEmailId: userDetails.emailId,
      conversationId: selectedLeadNumber,
      incoming: false,
      key: {
        projectId: localStorage.getItem("currentProjectId"),
        leadId: leadNumberToIdMap[selectedLeadNumber] || null,
        socialPlatform: socialPlatform,
        time: chatTime,
      },
    };

    // Send via WebSocket safely
    this.sendViaWebSocket(chatMessage);

    // Update conversation metadata
    const conversationId = selectedLeadNumber.replace("+", "");
    const existingConversation = window.escalatedChatDataMap[conversationId];

    const selectedConversation = this.getOrUpdateConversation(
      chatMessage,
      userDetails,
      existingConversation,
      socialPlatform
    );

    const formattedData = this.formatSingleUtterance(chatMessage, selectedConversation);

    // Update state with the new message
    this.setState((prevState) => ({
      leadUtteranceArray: [...(prevState.leadUtteranceArray || []), formattedData],
      showChatsPopUp: false,
    }));

    // Reset input field
    if (inputElement) inputElement.value = "";

    console.log("My Text message is shown");

    // Optionally refresh leads
    if (showGoogleRcs) {
      this.fetchActiveLeads();
    }
  };
  getSelectedLeadNumber = (fallbackLead) => {
    const stored = localStorage.getItem("selectedLeadNumber");
    return stored && stored !== "null" ? stored : fallbackLead;
  };
  getUserDetails = () => {
    return JSON.parse(localStorage.getItem("user_details") || "{}");
  };
  sendViaWebSocket = (message) => {
    const socket = this.chatSocket;
    const msgStr = JSON.stringify(message);
    if (!socket || socket.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket not ready. Trying to reconnect...");
      this.initWebSocket(() => this.chatSocket.send(msgStr));
    } else {
      socket.send(msgStr);
    }
  };
  getOrUpdateConversation = (chatMessage, userDetails, existing, socialPlatform) => {
    const conversationId = chatMessage.destination.replace("+", "");
    let conversation = existing || {
      userDisplayName: chatMessage.leadName,
      id: conversationId,
      salesUserName: userDetails.name,
      userPhoneNumber: chatMessage.destination,
      conversationId: conversationId,
      status: "seen",
    };

    if (existing && existing.socialPlatform !== socialPlatform) {
      conversation = { ...conversation, status: "new" };
    }

    window.escalatedChatDataMap[conversationId] = {
      ...conversation,
      socialPlatform,
    };

    return conversation;
  };

  formatSingleUtterance = (singleUtteranceData, selectedConversation) => {
    console.log("Formatting utterance");
    var userPicUrl = "";
    var selectedUserName =
      selectedConversation.userDisplayName.charAt(0).toUpperCase() +
      selectedConversation.userDisplayName.slice(1);
    var username = selectedUserName;
    var changeFontColor = false;
    var utteranceType;
    var incoming = singleUtteranceData.incoming;

    if (!singleUtteranceData.incoming) {
      if (singleUtteranceData.escalationSupportUserJid === null) {
        userPicUrl = "./assets/images/dhee_small_round.png";
      } else {
        userPicUrl = "./assets/images/support_user.png";
      }
      username = selectedConversation.salesUserName;
      utteranceType = "Sent";
    } else {
      userPicUrl = "./assets/images/user-blue-icon-64.png";
      utteranceType = "Received";
    }

    var date = new Date();
    var utteranceTime =
      this.getTime(date) + ", " + date.toLocaleDateString("en-GB");
    var utteranceData = {
      userName: username,
      utteranceText: singleUtteranceData.text,
      utteranceTime: utteranceTime,
      userPicUrl: userPicUrl,
      utteranceType: utteranceType,
      longUtteranceTime: singleUtteranceData.time,
      type: singleUtteranceData.messageType,
      changeFontColor: changeFontColor,
      incoming: incoming,
      messageStatus: singleUtteranceData.messageStatus,
      errorMessage: singleUtteranceData.errorMessage,
      messageId: `${singleUtteranceData.destination}_${singleUtteranceData.key.time}_${singleUtteranceData.key.socialPlatform}`,
    };
    if (singleUtteranceData.type != "TEXT") {
      utteranceData.fileId = singleUtteranceData.fileId;
      utteranceData.fileName = singleUtteranceData.fileName;
    }
    console.log("Formatting utterance completed");
    return utteranceData;
  };

  setUtteranceListToView = (conversationId) => {
    console.log("Painting utterances of conversation ID : " + conversationId);
    var chatMessageController = this;
    // chatMessageController.state.leadUtteranceArray = [];

    var conversationUtterances =
      window.conversationIdUtteranceDataMap[conversationId];

    if (conversationUtterances) {
      console.log(
        "Got stored utterances : " + JSON.stringify(conversationUtterances)
      );
      var formattedUtterances = conversationUtterances;

      chatMessageController.state.convId = conversationId;
      chatMessageController.state.leadUtteranceArray = formattedUtterances;
      chatMessageController.setState(chatMessageController.state);
    }

    var discussionEle = document.querySelector("#esc-discussions");
    if (discussionEle != undefined && discussionEle != null) {
      setTimeout(() => {
        discussionEle.scrollTop = discussionEle.scrollHeight;
      }, 100);
    }
    console.log(
      "Painting utterances of conversation ID : " +
      conversationId +
      " Completed."
    );
  };

  setEscalatedChatList = () => {
    var chatMessageController = this;
    var extractedData = chatMessageController.getArrayFromMap(
      chatMessageController.state.activeLeadsArray
    );
    chatMessageController.state.activeLeadsArray = extractedData;
    chatMessageController.state.activeLeadsArray;
    chatMessageController.setState(chatMessageController.state);
  };

  showHistoryApi = (userPhoneNumber, leadIdDef) => {
    var chatMessageController = this;
    let leadId = chatMessageController.state.leadNumberToIdMap[userPhoneNumber];
    console.log({
      leadId,
      idMap: chatMessageController.state.leadNumberToIdMap,
    });
    if (!leadId && leadIdDef) {
      leadId = leadIdDef;
    }
    let socialPlatform = localStorage.getItem("selectedSocialPlatform");
    if (!socialPlatform) {
      socialPlatform = this.state.selectedGoogleRcs ? "GOOGLE_RCS" : "WHATSAPP";
    }
    $.ajax({
      url: "/salesdesk-api/fetch-lead-conversation",
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        leadId: leadId,
        socialPlatform: socialPlatform,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      success: (res) => {
        if (res.success) {
          const leadConversation = res.result.map((item) => ({
            longUtteranceTime: item.key.time,
            type: item.messageType,
            userName: item.incoming
              ? item.leadName
              : JSON.parse(localStorage.getItem("user_details")).name,
            userPicUrl: item.incoming
              ? "./assets/images/user-blue-icon-64.png"
              : "./assets/images/support_user.png",
            utteranceText: item.templateName
              ? `The Template: ${item.templateName}`
              : item.text || "",
            utteranceType: item.incoming ? "Received" : "Sent",
            utteranceTime: `${chatMessageController.getTime(
              new Date(item.time)
            )}, ${new Date(item.time).toLocaleDateString("en-GB")}`,
            messageStatus: item.messageStatus,
            incoming: item.incoming,
            messageId: item.id,
            errorMessage: item.errorMessage,
            ...(item.fileName && {
              fileId: item.fileId,
              fileName: item.fileName,
            }),
            // Generate a unique messageId
            messageId: `${userPhoneNumber}_${item.key.time}_${socialPlatform}`,
          }));

          localStorage.setItem("selectedConversationId", leadId);
          chatMessageController.setUtteranceListToView(leadId);
          if (leadConversation.length > 0) {
            chatMessageController.state.leadUtteranceArray = leadConversation;
          }
          chatMessageController.setState(chatMessageController.state);
        } else {
          chatMessageController.notifyError(res.result);
        }
      },
      error: (xhr) => {
        if (xhr.status === 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  markMessagesAsReadApi = (props, e) => {
    var dailyConversationController = this;

    $.ajax({
      url: "/salesdesk-api/daily-conversation-mark-as-read",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        leadContactNumber: props,
        socialPlatform: localStorage.getItem("selectedSocialPlatform"),
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          dailyConversationController.setState(dailyConversationController);
        } else {
          dailyConversationController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      },
    });
  };

  onActiveLeadClick = (leadProps, e) => {
    const { userPhoneNumber, selectedSocialPlatform, leadId, conversationId } =
      leadProps;
    console.log(
      `Clicked on the lead: ${userPhoneNumber} with social platform: ${selectedSocialPlatform}`
    );
    localStorage.setItem("selectedSocialPlatform", selectedSocialPlatform);
    localStorage.setItem("selectedLeadNumber", userPhoneNumber);
    var leadNumberToIdMap = this.state.leadNumberToIdMap;
    if (!leadNumberToIdMap[userPhoneNumber]) {
      this.state.leadNumberToIdMap[userPhoneNumber] = leadId;
      this.setState(this.state);
    }
    // Fetch past conversations and mark the lead as read
    this.showHistoryApi(userPhoneNumber, leadId);
    this.markMessagesAsReadApi(userPhoneNumber);

    // Update the active leads array to highlight the clicked lead
    const updatedLeadsArray = this.updateActiveLeadsArray(conversationId);
    this.setState({ activeLeadsArray: updatedLeadsArray });
    this.setHighlightedChatId(conversationId);
  };

  updateActiveLeadsArray = (conversationId) => {
    return this.state.activeLeadsArray.map((lead) => {
      if (lead.conversationId === conversationId) {
        return {
          ...lead,
          handleClick: true,
          unreadMessages: 0,
        };
      }
      return lead;
    });
  };

  setHighlightedChatId = (conversationId) => {
    this.setState((prevState) => {
      const { highLightedChatIdList } = prevState;
      const isHighlighted = highLightedChatIdList.includes(conversationId);

      return {
        highLightedChatIdList: isHighlighted
          ? highLightedChatIdList.filter((id) => id !== conversationId)
          : [...highLightedChatIdList, conversationId],
      };
    });
  };

  notifyMe = (title, body, conversationId) => {
    var chatMessageController = this;
    try {
      if (Notification.permission !== "granted")
        Notification.requestPermission();
      else {
        var date = new Date();
        var longTimeVal = date.getTime();
        var audio = new Audio("./assets/audio/notification.mp3");
        audio.play();
        var notification = new Notification(title, {
          id: longTimeVal,
          icon: "./assets/images/dhee_small.png",
          body: body,
          data: conversationId,
        });
        setTimeout(function () {
          notification.close();
        }, 8000);
        notification.onclick = function (event) {
          console.log("notification click happened");

          if (
            chatMessageController.state.highLightedChatIdList.includes(
              conversationId
            )
          ) {
            var index =
              chatMessageController.state.highLightedChatIdList.indexOf(
                conversationId
              );
            chatMessageController.state.highLightedChatIdList.splice(index, 1);
            chatMessageController.state.selectedLeadNumber = conversationId;
          }

          // $("#whatsapp").addClass('activemenu');
          // $("#reports").removeClass('activemenu');
          // $("#sales-desk-settings").removeClass('activemenu');
          // chatMessageController.props.onClickNotification();
          // window.displayUtterances = false;
          // chatMessageController.showHistoryApi();

          chatMessageController.props.history.push({
            pathname: "/projectmgmt/",
          });
          chatMessageController.showHistoryApi(conversationId);

          toast.dismiss();
          window.focus();
          notification.close();
        };
      }
    } catch (err) {
      console.log("Notifying the user failed: " + err.message);
    }
  };

  componentWillUnmount() {
    clearTimeout(window.importStatusTimeoutHandle);
    clearTimeout(window.exportStatusTimeoutHandle);
  }

  sendUploadedDocument = () => {
    const sendUploadedDocumetController = this;

    const leadId = localStorage.getItem("selectedConversationId");
    const leadNumber = localStorage.getItem("selectedLeadNumber");

    if (!leadId) {
      sendUploadedDocumetController.notifyWarning("No conversation selected.");
      return;
    }

    const fileInput = document.getElementById("file-input");
    const file = fileInput && fileInput.files ? fileInput.files[0] : undefined;

    if (!file) {
      sendUploadedDocumetController.notifyWarning("No file selected.");
      return;
    }

    const fileName = file.name.toLowerCase();
    const fileExtension = (fileName.split(".").pop() || "").toLowerCase();

    const mimeMap = {
      txt: "text/plain",
      pdf: "application/pdf",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      csv: "text/csv",
      json: "application/json",
      zip: "application/zip",
    };

    const mimeType = mimeMap[fileExtension];

    if (!mimeType) {
      console.error(`MIME type for ${fileName} not found.`);
      return;
    }

    if (
      !sendUploadedDocumetController.state.advancePropertyfileTypes.includes(
        fileExtension
      )
    ) {
      sendUploadedDocumetController.notifyWarning(
        `Only ${sendUploadedDocumetController.state.advancePropertyValueString} upload is allowed.`
      );
      return;
    }

    console.log("Uploading file:", file.name, mimeType);

    const formData = new FormData();
    formData.append("projectId", localStorage.getItem("currentProjectId"));
    formData.append("leadId", leadId);
    formData.append(
      "socialPlatform",
      localStorage.getItem("selectedSocialPlatform")
    );
    formData.append("document", file);

    $.ajax({
      url: "/salesdesk-api/send-uploaded-document",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      success: (res) => {
        if (res.success) {
          sendUploadedDocumetController.showHistoryApi(leadNumber);
        } else {
          sendUploadedDocumetController.notifyWarning(res.result);
        }
      },
      error: (xhr) => {
        if (xhr.status === 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  notifyWarning(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }

  notifyResponse(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
    });
  }

  notifyFailToUpload() {
    toast(
      <b style={{ color: "red" }}>
        Oops! Error occurred while uploading. Please try again
      </b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }
  notifyUploaded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp; Your batch has been uploaded successfully{" "}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  getArrayFromMap = (dataMap) => {
    var escChatController = this;
    var extractedData = [];
    var dataMapEntries = [];
    for (var index in dataMap) {
      dataMapEntries.push(dataMap[index]);
    }
    for (var i = 0; i < dataMapEntries.length; i++) {
      var parsedEscalation = dataMapEntries[i];
      parsedEscalation.color = "Warning";
      parsedEscalation.status = "new";
      parsedEscalation.handleClick = false;

      var conversationUtterances =
        window.conversationIdUtteranceDataMap[parsedEscalation.conversationId];

      if (conversationUtterances) {
        parsedEscalation.color = "Success";
        parsedEscalation.escalationTag = "read";
      }

      var incomingChatLogo = "";

      if (conversationUtterances) {
        var lastUtteranceOfConversation =
          conversationUtterances[conversationUtterances.length - 1];
        parsedEscalation.uxType = lastUtteranceOfConversation.uxType;
        if (lastUtteranceOfConversation.uxType === "WIDGET") {
          incomingChatLogo = "./assets/images/web_icon_32.png";
        } else if (lastUtteranceOfConversation.uxType === "SOCIAL_MEDIA") {
          if (lastUtteranceOfConversation.uxSubType === "FB_MESSENGER") {
            incomingChatLogo = "./assets/images/facebook_logo_32.png";
          } else if (lastUtteranceOfConversation.uxSubType === "TWITTER") {
            incomingChatLogo = "./assets/images/twitter_logo_32.png";
          }
        } else if (lastUtteranceOfConversation.uxType === "TELEPHONY") {
          incomingChatLogo = "./assets/images/telephony_logo_32.png";
        } else if (lastUtteranceOfConversation.uxType === "APP") {
          incomingChatLogo = "./assets/images/android_logo_32.png";
        }
      }
      incomingChatLogo = "./assets/images/web_icon_32.png";
      parsedEscalation.incomingChatLogo = incomingChatLogo;
      extractedData.push(parsedEscalation);
    }
    return extractedData;
  };

  groupTemplate(data) {
    return (
      <div>
        <span className="category">{data.items[0].escalationTag}</span>
        <span className="count"> {data.items.length} Item(s)</span>
      </div>
    );
  }

  getTime = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var aa = "AM";
    if (hours < 12) {
      aa = "AM";
    } else {
      hours = Number(hours) - 12;
      aa = "PM";
    }
    if (hours == 0) {
      hours = 12;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    return hours + ":" + minutes + " " + aa;
  };
  onKeyPressHandleChange = (event) => {
    if (event.key === "Enter") {
      this.sendMessage();
    }
  };

  fetchTemplatesInProject = () => {
    let templatesController = this;
    const projectId = localStorage.getItem("currentProjectId");
    const accessToken = localStorage.getItem("access_token");

    $.ajax({
      url: "/salesdesk-api/whatsapp/templates",
      async: false,
      method: "GET",
      data: { projectId },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      success: function (res) {
        if (res.success === true) {
          const projectTemplates = res.result || [];
          const templateMap = {};
          let defaultTemplate = "";
          let numberOfParams = 0;
          let selectedValue = (templatesController.state && templatesController.state.value) || "";

          projectTemplates.forEach((projectTemplate) => {
            if (!projectTemplate) return;

            templateMap[projectTemplate.name] = projectTemplate;

            if (projectTemplate.approved !== false) {
              // Collect approved templates
              defaultTemplate = defaultTemplate || projectTemplate.name;  // Set default template
            }

            // Check for default template and number of params
            if (selectedValue === projectTemplate.name || selectedValue === "") {
              selectedValue = projectTemplate.name;
              numberOfParams = projectTemplate.noOfParams;
            }
          });

          templatesController.setState({
            projectTemplates,
            projectTemplatesMap: templateMap,
            value: defaultTemplate,
            numberOfParams,
            selectedTemplateContent:
              templateMap[defaultTemplate] && templateMap[defaultTemplate].content
                ? templateMap[defaultTemplate].content
                : "",
          });
        } else {
          templatesController.notifyError(res.result || "Failed to fetch templates.");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        } else {
          console.error(`Error fetching templates: ${xhr.status}: ${xhr.statusText}`);
        }
      },
    });
  };

  handleChangeOfTemplate = (event) => {
    const chosenTemplateName = event.target.value;
    const chosenTemplate = this.state.projectTemplatesMap[chosenTemplateName];

    this.setState({
      value: chosenTemplateName,
      numberOfParams: chosenTemplateName === "hello_world" ? 0 : chosenTemplate.noOfParams,
      selectedTemplateContent:
        chosenTemplate && chosenTemplate.content ? chosenTemplate.content : "",
    });
  };

  handleWhatsappChange = (e) => {
    //  const showWhatsapp = this.state.showWhatsapp;
    //  const showGoogleRcs = this.state.showGoogleRcs;
    this.setState({ showWhatsapp: e.target.checked, showGoogleRcs: false });
  };

  handleGoogleRcsChange = (e) => {
    // const showGoogleRcs = this.state.showGoogleRcs;
    // const selectedWhatsapp = this.state.selectedWhatsapp;
    this.setState({ showGoogleRcs: e.target.checked, showWhatsapp: false });
  };

  handleStartChat = () => {
    const initialMessageInput = document.getElementById("textMsg1");
    const initialMessage = initialMessageInput && initialMessageInput.value ? initialMessageInput.value.trim() : "";

    // Reset state and clear chat history
    this.setState({
      showChatsPopUp: false,
      leadUtteranceArray: [],
    });

    // Transfer initial message to main input
    const mainTextInput = document.getElementById("textMsg");
    if (mainTextInput) {
      mainTextInput.value = initialMessage;
    }
    if (initialMessageInput) {
      initialMessageInput.value = "";
    }

    const selectedSocialPlatform = this.state.showGoogleRcs
      ? "GOOGLE_RCS"
      : "WHATSAPP";

    localStorage.setItem("selectedConversationId", "");
    localStorage.setItem("selectedLeadNumber", "");
    localStorage.setItem("selectedSocialPlatform", selectedSocialPlatform);

    if (selectedSocialPlatform === "WHATSAPP") {
      this.startChatBySendingTemplate();
      setTimeout(() => this.fetchActiveLeads(), 1500);
    } else {
      this.sendMessage();
    }
  };


  refreshData = () => {
    this.setState(
      {
        selectedWhatsapp: false,
        selectedGoogleRcs: false,
        showWhatsapp: false,
        showGoogleRcs: false,
        leadUtteranceArray: [],
      },
      () => {
        this.fetchActiveLeads();
      }
    );
  };

  handleParamChange = (index, value) => {
    const updatedParams = [...this.state.templateParams];
    updatedParams[index] = value;
    this.setState({ templateParams: updatedParams });
  };

  render() {
    const filteredOptions = this.state.maskPhoneNumbers ? [] : this.loadLeads;

    const columns1 = [
      {
        Header: <b>Messages</b>,
        minWidth: 17,
        textAlign: "screenLeft",
        accessor: "text",
        sortable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => (
          <div
            className={
              props.original.utteranceType == "Sent"
                ? "direct-chat-msg right"
                : "direct-chat-msg"
            }
            align={props.original.utteranceType == "Sent" ? "right" : "left"}
            style={{
              marginLeft:
                props.original.utteranceType == "Sent" ? "35%" : "0px",
              marginRight:
                props.original.utteranceType == "Sent" ? "0px" : "35%",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="direct-chat-text chat_left textarea"
              style={{
                width: "auto",
                height: "auto",
                backgroundColor:
                  props.original.utteranceType == "Sent"
                    ? "#eef2ff" /* brand-50 */
                    : "#f1f5f9", /* slate-100 */
                color: "#0f172a", /* slate-900 */
                border: "1px solid",
                borderColor:
                  props.original.utteranceType == "Sent"
                    ? "#c7d2fe" /* brand-200 */
                    : "#e2e8f0", /* slate-200 */
                borderRadius: "0.75rem",
                padding: "0.625rem 0.875rem",
                marginTop: "-10px",
                textAlign: "left",
                boxShadow: "0 1px 2px 0 rgba(15, 23, 42, 0.04)",
              }}
            >
              <div
                className="row"
                style={{
                  textAlign: "left",
                }}
              >
                <div
                  className="col-sm-1"
                  style={{ maxWidth: "4%", paddingLeft: "0px" }}
                >
                  <img
                    src={props.original.userPicUrl}
                    width="50px"
                    height="50px"
                  />
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div className="col-sm-10" style={{ minWidth: "300px" }}>
                  <span
                    style={{
                      color:
                        props.original.changeFontColor != null &&
                          props.original.changeFontColor
                          ? "red"
                          : "black",
                    }}
                    readOnly={true}
                  >
                    {props.original.userName} :{" "}
                  </span>
                  {props.original.type == "TEXT" ? (
                    <span
                      style={{
                        color:
                          props.original.changeFontColor != null &&
                            props.original.changeFontColor
                            ? "red"
                            : "black",
                      }}
                      readOnly={true}
                    >
                      {props.original.utteranceText.split(/\n/).map((line) => (
                        <span>
                          {line}
                          <br />
                        </span>
                      ))}
                    </span>
                  ) : props.original.type == "DOCUMENT" ? (
                    <a
                      href={
                        "/salesdesk-api/social/file/download?fileId=" +
                        props.original.fileId
                      }
                      target="_blank"
                    >
                      <br />
                      <img src="./assets/images/document.png"></img>
                      {props.original.fileName}
                      <br />
                    </a>
                  ) : props.original.type == "IMAGE" ? (
                    <a
                      href={
                        "/salesdesk-api/social/file/download?fileId=" +
                        props.original.fileId
                      }
                      target="_blank"
                    >
                      <br />
                      <img
                        src={
                          "/salesdesk-api/social/file/download?fileId=" +
                          props.original.fileId
                        }
                        style={{ height: "auto", width: "315px" }}
                      ></img>
                      <br />
                    </a>
                  ) : props.original.type == "AUDIO" ? (
                    <audio controls>
                      <source
                        src={
                          "/salesdesk-api/social/file/download?fileId=" +
                          props.original.fileId
                        }
                      />
                    </audio>
                  ) : props.original.type == "VIDEO" ? (
                    <video controls>
                      <source
                        src={
                          "/salesdesk-api/social/file/download?fileId=" +
                          props.original.fileId
                        }
                      />
                    </video>
                  ) : (
                    <span readOnly={true}>
                      {props.original.utteranceText.split(/\n/).map((line) => (
                        <span>
                          {line}
                          <br />
                        </span>
                      ))}
                    </span>
                  )}

                  <div
                    style={{
                      display:
                        props.original.messageStatus == "ERROR" &&
                          props.original.incoming == false
                          ? "block"
                          : "none",
                      padding: "0.5rem",
                      color: "red",
                      padding: "0.5rem",
                      fontWeight: "500",
                      width: "fitContent",
                      marginTop: "0.5rem",
                      wordWrap: "break-word",
                    }}
                  >
                    {props.original.errorMessage}
                  </div>
                  <span style={{ fontSize: "0.7rem" }} readOnly={true}>
                    {props.original.utteranceTime}
                  </span>

                  <span
                    style={{
                      fontSize: "0.7rem",
                      fontWeight: "bold",
                      display:
                        props.original.incoming ||
                          props.original.incoming == null
                          ? "none"
                          : "block",
                      float: "right",
                      marginTop: "1.2rem",

                      color:
                        props.original.messageStatus == "ERROR"
                          ? "red"
                          : props.original.messageStatus == "SENT"
                            ? "rgb(113 112 108)"
                            : props.original.messageStatus == "DELIVERED"
                              ? "#155bc9e8"
                              : "#1baf1b",
                    }}
                    readOnly={true}
                  >
                    {!props.original.messageStatus
                      ? ""
                      : " " + props.original.messageStatus}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ),
      },
    ];
    const activeLead = [
      {
        Header: <b>Active Leads</b>,
        textAlign: "screenLeft",
        accessor: "text",
        sortable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => (
          <div
            className="e-list-wrapper"
            style={{
              lineHeight: "5px",
              backgroundColor:
                props.original.conversationId == this.state.convId
                  ? "#F5F5F5"
                  : "#ffffff",
              display: "flex",
              // alignItems: "center",
              gap: "5px",
            }}
            onClick={(e) => this.onActiveLeadClick(props.original, e)}
          >
            <div style={{ width: "4rem", height: "3rem" }}>
              <img
                src={`${props.original.selectedSocialPlatform == "GOOGLE_RCS"
                  ? "assets/images/RCS_logo.png"
                  : "assets/images/whatsapp-logo.png"
                  }`}
                alt="social_logo"
                style={{ width: "100%" }}
              />
            </div>
            <div>
              <label
                className="e-list-content"
                style={{
                  display:
                    props.original.unreadMessages === 0 ? "none" : "block",
                  color: "white",
                  backgroundColor: "#282a65",
                  marginLeft: "23vw",
                  height: "2vw",
                  width: "2vw",
                  lineHeight: "2vw",
                  borderRadius: "2vw",
                  textAlign: "center",
                  marginBottom: "-2vw",
                }}
              >
                {props.original.unreadMessages}
              </label>
              <label
                className="e-list-content"
                style={{
                  color: "#000000",
                  border: "none",
                  resize: "none",
                  margin: "10px",
                  fontSize: "16px",
                  fontWeight: this.state.highLightedChatIdList.includes(
                    props.original.conversationId
                  )
                    ? "bold"
                    : "unset",
                }}
              >
                {props.original.userDisplayName}
              </label>
              <br />
              <label
                className="e-list-content"
                style={{
                  color: "#000000",
                  border: "none",
                  resize: "none",
                  margin: "10px",
                  fontSize: "14px",
                  fontWeight: this.state.highLightedChatIdList.includes(
                    props.original.conversationId
                  )
                    ? "bold"
                    : "unset",
                }}
              >
                {props.original.userPhoneNumberToDisplay}
              </label>
              <br />
              <label
                className="e-list-content"
                style={{
                  display: props.original.enterpriseCrmId ? "block" : "none",
                  color: "#000000",
                  border: "none",
                  resize: "none",
                  margin: "10px",
                  fontSize: "14px",
                  fontWeight: this.state.highLightedChatIdList.includes(
                    props.original.conversationId
                  )
                    ? "bold"
                    : "unset",
                }}
              >
                {props.original.enterpriseCrmId}
              </label>
              <br />
            </div>
          </div>
        ),
      },
    ];
    return (
      <div id="tabPage" style={{ height: "35vw" }}>
        <div
          className="content"
          style={{ backgroundColor: "#F9F9FB", marginLeft: "-10px" }}
        >
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          <link rel="stylesheet" href="assets/css/uploadFile.css" />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          <ToastContainer className="Toast-at-center" />

          {/* <div className="col-sm-2 " style={{ marginTop: '-18px', float: "right", marginRight: "2rem" }}>
              <div className="d-flex flex-row-reverse pt-2">

                <div className="p-2" style={{ marginBottom: '10px' }}>

                  <button className="btn action-button"
                    id="addMsg" title=" Add "
                    onClick={this.state.disabled ? this.notifyEmptyFieldForAdd : this.addRow}>
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                    <img src="./assets/images/refresh_white_24dp.png"></img></button>
                </div>
              </div>
            </div> */}

          <div
            className="chat-template"
            style={{ marginLeft: "13px", width: "100%" }}
          >
            <div
              className="row"
              style={{ display: "block", width: "100%", marginLeft: "2rem" }}
            >
              <div
                className="col-sm-8"
                style={{
                  display: this.state.selectedWhatsapp ? "block" : "none",
                }}
              >
                <h6 className="taglineTxt">Select Template</h6>

                <select
                  id="loadTemplate1"
                  value={this.state.value}
                  onChange={this.handleChangeOfTemplate}
                  style={{
                    width: "25%",
                    height: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#F9F9FB",
                  }}
                >
                  {/* <option value="hello_world">Hello World!</option> */}
                </select>
              </div>
            </div>

            <div
              className="col-sm-3"
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "baseline",
                marginRight: "2rem",
              }}
            >
              <div
                className=""
                align="right"
                style={{
                  display:
                    this.state.selectedWhatsapp || this.state.selectedGoogleRcs
                      ? "block"
                      : "none",
                  marginLeft: "5rem",
                  float: "right",
                }}
              >
                <ComboBox
                  options={filteredOptions}
                  enableAutocomplete
                  id="comboBoxValue"
                  onChange={(e) => this.handleLeadChange(e.target.value)}
                  onSelect={(e) => this.handleLeadChange(e)}
                  placeholder="Enter phone number"
                />
              </div>

              <button
                className="btn-primary"
                id="start"
                title="Start"
                style={{
                  display: this.state.selectedWhatsapp ? "inline-flex" : "none",
                  marginTop: "1vw",
                }}
                onClick={this.startChatBySendingTemplate}
              >
                Start
              </button>

              <button
                className="btn-primary"
                id="addMsg"
                title="Start new conversation"
                style={{
                  display:
                    this.state.selectedWhatsapp || this.state.selectedGoogleRcs
                      ? "none"
                      : "inline-flex",
                }}
                onClick={(e) => this.setState({ showChatsPopUp: true })}
              >
                <img
                  src="assets/images/add_white_24dp.png"
                  alt=""
                  style={{ width: 16, height: 16 }}
                />
                Start New Conversation
              </button>
              <button
                title="Refresh"
                onClick={this.refreshData}
                type="button"
                className="btn-secondary"
              >
                <img
                  src="./assets/images/refresh_white_24dp.png"
                  alt=""
                  style={{ width: 16, height: 16, filter: "invert(35%)" }}
                />
              </button>
            </div>
          </div>
          <div
            className="row"
            style={{
              marginLeft: "13px",
              overflowX: "scroll",
              display: this.state.selectedWhatsapp ? "block" : "none",
            }}
            id="paramsRow"
          >
            {Array.apply(null, { length: this.state.numberOfParams }).map(
              (e, i) => (
                <div
                  className="col-sm-2"
                  align="right"
                  style={{ marginTop: "1vw" }}
                >
                  <input
                    type="text"
                    placeholder={"Parameter " + i + " Value"}
                    style={{
                      display: this.state.numberOfParams > 0 ? "block" : "none",
                      backgroundColor: "white",
                      width: "90%",
                      height: "2vw",
                      borderBottom: "1px solid black",
                    }}
                    id={"param" + i}
                  />
                </div>
              )
            )}
          </div>

          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-lg-4 escalationBox"
                >
                  <div className="card" style={{ height: "36rem" }}>
                    <div className="table-responsive logTableBox scrollableTableBox"
                      style={{ overflowY: "auto", maxHeight: "100%" }}>
                      <ReactTable
                        id="activeLeadConv"
                        data={this.state.activeLeadsArray}
                        showPagination={false}
                        columns={activeLead}
                        style={{ backgroundColor: "white" }}
                        pageSize={this.state.activeLeadsArray.length || 5}
                      />
                    </div>
                  </div>
                  {/* <div className="card-footer clearfix">

                                        </div> */}
                </div>
                <div className="col-lg-8" style={{ paddingBottom: "2.5rem" }}>
                  <div className="card" style={{ height: "36rem" }}>
                    <div
                      className="card chat_log"
                      id="esc-discussions"
                      style={{
                        height: "30rem",
                        overflowY:
                          this.state.leadUtteranceArray.length < 4 ? "unset" : "auto",
                      }}
                    >
                      <ReactTable
                        id="reactTable"
                        data={this.state.leadUtteranceArray}
                        noDataText={
                          <div style={{ textAlign: "center" }}>
                            <img
                              src="./assets/images/warn.svg"
                              style={{ height: "3rem", width: "3rem" }}
                            />
                            <br />
                            <br />
                            <label style={{ fontSize: "1.25rem" }}>
                              Not Attending Any Conversation Now
                            </label>
                            <br />
                            <label style={{ fontSize: "1rem" }}>
                              Please click on the conversation shown on left panel to load it.
                            </label>
                          </div>
                        }
                        columns={columns1}
                        showPagination={false}
                        pageSize={
                          this.state.leadUtteranceArray.length < 7
                            ? 7
                            : this.state.leadUtteranceArray.length
                        }
                        getTdProps={() => ({
                          style: {
                            border: "none",
                            height: "auto",
                          },
                        })}
                      />
                    </div>

                    <div
                      className="row align-items-center"
                      style={{
                        background: "#fff",
                        border: "1px solid #e2e8f0", /* slate-200 */
                        borderRadius: "0.75rem",
                        height: "4.5rem",
                        margin: "1rem 1rem 1rem 1%",
                        padding: "0 1rem",
                        boxShadow:
                          "0 1px 2px 0 rgba(15, 23, 42, 0.04), 0 1px 3px 0 rgba(15, 23, 42, 0.06)",
                      }}
                    >
                      <div className="col-sm-1 text-center">
                        <img
                          src="./assets/images/support_user.png"
                          alt="User"
                          style={{
                            width: "2.5rem",
                            height: "2.5rem",
                            borderRadius: "9999px",
                            border: "1px solid #e2e8f0",
                          }}
                        />
                      </div>

                      <div className="col-sm-8">
                        <input
                          id="textMsg"
                          className="input-field"
                          placeholder="Type your message"
                          onKeyPress={this.onKeyPressHandleChange}
                        />
                      </div>

                      <div
                        className="col-sm-3"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <input
                          onInput={this.sendUploadedDocument}
                          className="file-input__input"
                          type="file"
                          name="file-input"
                          id="file-input"
                          accept={this.state.advancePropertyValueString}
                          disabled={!localStorage.getItem("selectedConversationId")}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor="file-input"
                          className="btn-secondary"
                          title="Attach a file"
                          style={{
                            cursor: localStorage.getItem("selectedConversationId")
                              ? "pointer"
                              : "not-allowed",
                            opacity: localStorage.getItem("selectedConversationId") ? 1 : 0.5,
                            pointerEvents: localStorage.getItem("selectedConversationId")
                              ? "auto"
                              : "none",
                            margin: 0,
                          }}
                        >
                          <svg
                            data-icon="upload"
                            role="img"
                            viewBox="0 0 512 512"
                            width="16"
                            height="16"
                            style={{ fill: "currentColor" }}
                          >
                            <path
                              fill="currentColor"
                              d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                            ></path>
                          </svg>
                          <span>Attach</span>
                        </label>

                        <button
                          className="btn-primary"
                          style={{
                            opacity: localStorage.getItem("selectedConversationId") ? 1 : 0.5,
                            pointerEvents: localStorage.getItem("selectedConversationId")
                              ? "auto"
                              : "none",
                          }}
                          onClick={this.sendMessage}
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="wrapper">
            <div
              className="modal"
              style={{ display: this.state.showChatsPopUp ? "block" : "none" }}
            >
              <div
                className="modal-dialog"
                id="center-aligned-account-modal"
              >
                <div
                  className="modal-content"
                  style={{
                    height: this.state.showWhatsapp ? "45rem" : "30rem",
                    width: "72rem",
                    overflowY: "auto",
                    padding: "2rem",
                    borderRadius: "1rem",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="modal-header noBorder" style={{ height: "2rem" }}>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      id="close_id"
                      onClick={() =>
                        this.setState({
                          showChatsPopUp: false,
                          selectedGoogleRcs: false,
                          selectedWhatsapp: false,
                          selectedLead: "",
                          value: "",
                          numberOfParams: 0,
                          templateParams: [],
                          selectedTemplateContent: "",
                        })
                      }
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </button>
                  </div>

                  <div className="modal-body" style={{ overflowY: "auto" }}>
                    <div className="select-inputs" style={{ display: "flex", flexDirection: "column", gap: "2rem", marginRight: "3rem" }}>
                      {/* WhatsApp Section */}
                      <div className="input-item" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                        {/* Row 1: Checkbox, Label, and ComboBox */}
                        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                          <input
                            type="checkbox"
                            className="input-checkbox"
                            checked={this.state.showWhatsapp}
                            onChange={this.handleWhatsappChange}
                            style={{ margin: 0 }}
                          />

                          {/* WhatsApp Icon */}
                          <img
                            src="assets/images/whatsapp-logo.png"
                            alt="WhatsApp Icon"
                            style={{ width: "3rem", objectFit: "contain" }}
                          />

                          <label className="text-label" style={{ margin: 0 }}>WhatsApp</label>

                          {this.state.showWhatsapp && (
                            <div style={{ flex: 1 }}>
                              <ComboBox
                                options={filteredOptions}
                                enableAutocomplete
                                id="comboBoxValue"
                                onChange={(e) => this.handleLeadChange(e.target.value)}
                                onSelect={(e) => this.handleLeadChange(e)}
                                placeholder="Enter phone number"
                              />
                            </div>
                          )}
                        </div>

                        {/* Row 2: Template selection and preview */}
                        {this.state.showWhatsapp && (
                          <React.Fragment>
                            {/* Template Dropdown */}
                            <div style={{ width: "100%" }}>
                              <label className="taglineTxt">Select Template</label>
                              <select
                                id="loadTemplate"
                                value={this.state.value}
                                onChange={this.handleChangeOfTemplate}
                                style={{
                                  width: "100%",
                                  height: "2.5rem",
                                  borderRadius: "0.5rem",
                                  backgroundColor: "#F9F9FB",
                                  padding: "0 1rem",
                                  marginTop: "0.5rem"
                                }}
                              >
                                {this.state.projectTemplates && this.state.projectTemplates.length > 0 ? (
                                  this.state.projectTemplates.map((template) => (
                                    <option key={template.name} value={template.name}>
                                      {template.name}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">No Templates Available</option>
                                )}
                              </select>
                            </div>

                            {/* Template Preview */}
                            {this.state.selectedTemplateContent && (
                              <div
                                style={{
                                  width: "100%",
                                  backgroundColor: "#f1f1f1",
                                  border: "1px solid #ccc",
                                  borderRadius: "0.5rem",
                                  padding: "0.75rem 1rem",
                                  whiteSpace: "pre-wrap",
                                  fontSize: "0.9rem",
                                  fontFamily: "monospace",
                                  marginTop: "0.5rem",
                                  color: "#333"
                                }}
                              >
                                {this.state.selectedTemplateContent}
                              </div>
                            )}

                            {/* Params Row */}
                            <div style={{ overflowX: "auto", width: "100%" }}>
                              <div
                                id="paramsRow"
                                style={{
                                  display: "flex",
                                  flexWrap: "nowrap",
                                  gap: "1rem",
                                  paddingTop: "1rem",
                                  minWidth: "100%",
                                }}
                              >
                                {Array.from({ length: this.state.numberOfParams }).map((_, i) => (
                                  <input
                                    key={`param-${i}`}
                                    type="text"
                                    placeholder={`Parameter ${i + 1} Value`}
                                    value={this.state.templateParams[i] || ""}
                                    onChange={(e) => this.handleParamChange(i, e.target.value)}
                                    style={{
                                      backgroundColor: "white",
                                      width: "15rem",
                                      height: "2.5rem",
                                      borderBottom: "1px solid #ccc",
                                      padding: "0.5rem",
                                      borderRadius: "0.4rem",
                                      flexShrink: 0, // Prevent shrinking in overflow
                                    }}
                                  />
                                ))}
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                      </div>

                      {/* Google RCS Section */}
                      <div className="input-item" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                          <input
                            type="checkbox"
                            className="input-checkbox"
                            checked={this.state.showGoogleRcs}
                            onChange={this.handleGoogleRcsChange}
                            style={{ margin: 0 }}
                          />

                          {/* Google RCS Icon */}
                          <img
                            src="assets/images/RCS_logo.png"
                            alt="Google RCS Icon"
                            style={{ width: "3.2rem", objectFit: "contain" }}
                          />

                          <label className="text-label" style={{ margin: 0 }}>Google RCS</label>

                          {this.state.showGoogleRcs && (
                            <div style={{ flex: 1, display: "flex", gap: "1rem", alignItems: "center" }}>
                              <ComboBox
                                options={filteredOptions}
                                enableAutocomplete
                                id="comboBoxValue"
                                onChange={(e) => this.handleLeadChange(e.target.value)}
                                onSelect={(e) => this.handleLeadChange(e)}
                                placeholder="Enter phone number"
                                style={{ flex: 1 }}
                              />
                              <div
                                className="row"
                                style={{
                                  background: "white",
                                  border: "1px solid #ddd",
                                  borderRadius: "0.5rem",
                                  padding: "1rem",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "1rem",
                                  flex: 1,
                                }}
                              >
                                <img
                                  src="./assets/images/support_user.png"
                                  style={{ width: "3rem", height: "3rem" }}
                                />
                                <input
                                  id="textMsg1"
                                  style={{ flex: 1 }}
                                  onKeyPress={this.onKeyPressHandleChange}
                                  placeholder="Type your message"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal-footer noBorder"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderTop: "none",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary navyblue-btn"
                        data-dismiss="modal"
                        onClick={this.handleStartChat}
                        style={{
                          padding: "0.75rem 2rem",
                          borderRadius: "0.5rem",
                          fontSize: "1rem",
                        }}
                      >
                        Start Chat
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CustomerChat;



// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/CustomerChat.js